<template>
	<div class="chequeView">
		<a title="View" class="btn btn-sm akkurate-warning custom-pointer text-white" v-b-modal="String(data.id)">
			<span class="akkurate-small"> <font-awesome-icon :icon="['fas', 'eye']" /></span>
		</a>
		<b-modal :id="String(data.id)" ref="modal" size="xxl" @show="ModalOpened">
			<template #modal-title>
				<div class="w-100 d-flex align-items-center justify-content-between" style="padding-right: 1rem;">
					<h6 class="m-0 fw-bold text-green">PRESENT AND CLEAR CHEQUE</h6>

					<div class="row">
						<!-- PENDING, COMPLETED, FAILED, REVERSED,REJECTED, APPROVED-->
						<div class="text-end" v-if="
							data.trans_status !== 'COMPLETED' &&
							data.trans_status !== 'APPROVED' &&
							data.trans_status !== 'REJECTED' &&
							data.trans_status !== 'REVERSED' &&
							data.trans_status !== 'FAILED'">
							<b-button class="akkurate-danger-btn btn-size" v-b-modal.reject-cheque-modal>
								<font-awesome-icon class="me-2" :icon="['fas', 'close']" />
								Reject
							</b-button>
							<b-button v-if="stage_id != '1'" class="akkurate-orange btn-size"
								@click="reverseCheque(data.cheque_number)">
								<font-awesome-icon class="me-2" :icon="['fas', 'backward']" />
								Reverse
							</b-button>
							<b-button class="akkurate-green-btn btn-size" @click="approveCheque(data.cheque_number)">
								<font-awesome-icon class="me-2" :icon="['fas', 'forward']" />
								Approve
							</b-button>
						</div>
						<div class="text-end" v-if="
							data.trans_status !== 'COMPLETED' &&
							data.trans_status !== 'REVERSED' &&
							data.trans_status !== 'REJECTED' &&
							data.trans_status !== 'PENDING' &&
							data.trans_status !== 'FAILED'">
							<b-button v-if="stage_id != '1'" class="akkurate-orange btn-size"
								@click="reverseCheque(data.cheque_number)">
								<font-awesome-icon class="me-2" :icon="['fas', 'backward']" />
								Reverse
							</b-button>
							<b-button @click="clearCheque()" class="akkurate-green-btn btn-size"
								v-b-modal="data.trans_id + 'clear'"><font-awesome-icon class="me-2"
									:icon="['fas', 'hand-holding-dollar']" />Clear</b-button>
							<!-- <data-disbursement :loan_account="data" :institution="institution" :data="disbursement"
								:disbursement="'disbursement'"></data-disbursement> -->
						</div>
					</div>
				</div>
			</template>
			<div>
				<div class="row p-2" style="background-color: #E1ECF0 !important;">
					<div class="col text-center">
						<img :src="data.account?.customer?.passport_pic_path" style="height: 200px !important"
							class="img-fluid" alt="user-profile" />
						<p class="akkurate-green fw-bold akkurate-small mb-0" style="color: #006885 !important;">
							Profile Image
						</p>
					</div>
					<div class="col text-center">
						<img :src="data.account?.customer?.gh_card_front_path
							" alt="Default Image" style="height: 200px !important" class="img-fluid text-center" />
						<p class="akkurate-green fw-bold akkurate-small mb-0" style="color: #006885 !important;">
							ID Card Front
						</p>
					</div>
					<div class="col text-center">
						<img :src="data.account?.customer?.gh_card_back_path" alt="Default Image" style="height: 200px"
							class="img-fluid text-center" />
						<p class="akkurate-green fw-bold akkurate-small mb-0" style="color: #006885 !important">
							ID Card Back
						</p>
					</div>
					<div class="row col-3 d-flex akkurate-small" style="background-color: transparent !important;">
						<p class="fw-bolder p-0 m-0 col-12 text-uppercase" style="color: #006885 !important;">
							{{ getFullName }}
						</p>
						<p class="fw-bolder p-0 m-0 col-6 mt-auto" style="color: #006885;">
							{{ data.customer?.gender }}
						</p>
						<p class="fw-bolder p-0 m-0 col-6 mt-auto" style="color: #006885;">
							{{ getBranch }}
						</p>
						<p class="fw-bolder p-0 m-0 col-6" style="color: #006885;">ADDRESS:</p>
						<p class="text-wrap p-0 m-0 col-6" style="color: #006885;">
							{{ data.customer?.address }}
						</p>

						<p class="fw-bolder p-0 m-0 col-6" style="color: #006885;">TEL:</p>
						<p class="col-6 p-0 m-0" style="color: #006885;">
							{{ data.customer?.mobile }}
						</p>

						<p class="fw-bolder p-0 m-0 col-6" style="color: #006885;">EMAIL:</p>
						<p class="col-6 p-0 m-0" style="color: #006885;">
							{{ data.customer?.email }}
						</p>

						<p class="fw-bolder p-0 m-0 col-6" style="color: #006885;">REG DATE:</p>
						<p class="col-6 p-0 m-0" style="color: #006885;">
							{{ new Date(data.customer?.registered_date).toDateString() }}
						</p>
						<p class="fw-bolder p-0 m-0 col-6" style="color: #006885;">STAFF ID:</p>
						<p class="col-6 p-0 m-0" style="color: #006885;">
							ST{{ data.customer?.id }}
						</p>
					</div>
				</div>
				<div class="row akkurate-skyblue-bg text-white akkurate-small">
					<div class="col py-1 text-center">
						VALUE
						<span class="fw-bold" style="margin-left: 1rem;">{{ displayNumber(data.trans_amount) }}</span>
					</div>
					<div class="col py-1 text-center">
						CHEQUE NUM.
						<span class="fw-bold" style="margin-left: 1rem;">{{ displayNumber(data.cheque_number) }}</span>
					</div>
					<div class="col py-1 text-center">
						AVAILABLE BAL <span class="fw-bold" style="margin-left: 1rem;">{{
							displayNumber(data.account.available_balance) }}</span>
					</div>
					<div class="col py-1 text-center">
						DATE <span class="fw-bold" style="margin-left: 1rem;">{{ data.trans_date }}</span>
					</div>
					<div class="col py-1 text-center">
						REFERENCE <span class="fw-bold" style="margin-left: 1rem;">{{ data.code }}</span>
					</div>
				</div>
				<div class="row pt-2 ">
					<div class="col-12">
						<beat-loader-component v-if="isLoading" :isLoading="isLoading"></beat-loader-component>
					</div>


					<div class="col-4">
						<div class="col-12">
							<label class="akkurate-dark" for="recorded_date">Account Number</label>
							<b-form-group id="account_nunber" label-for="account_nunber">
								<b-form-input class="mb-3 mt-2 field-container fields" type="text"
									v-model="data.account.account_number" disabled></b-form-input>
							</b-form-group>
						</div>
						<div class="col-12">
							<label class="akkurate-dark" for="narration">Narration</label>
							<b-form-group id="narration" label-for="narration">
								<!-- <b-form-input class="mb-3 mt-3 field-container fields text-wrap" type="text-area" style="height: 6rem;" v-model="data.narration"
                                    disabled></b-form-input> -->

								<b-form-textarea class="mb-3 mt-2 field-container fields text-wrap" id="narration"
									v-model="data.narration" style="min-height: 114px !important;"
									disabled></b-form-textarea>
							</b-form-group>
						</div>
					</div>

					<div class="row col-8">
						<div class="col-12 col-md-6">
							<label class="akkurate-dark" for="pay_in_date">Pay-In Date</label>
							<b-form-group id="pay_in_date" label-for="pay_in_date">
								<b-form-input class="mb-3 mt-2 field-container fields" type="text"
									v-model="data.created_at" disabled></b-form-input>
							</b-form-group>
						</div>
						<div class="col-12 col-md-6">
							<label class="akkurate-dark" for="value_date">Value Date</label>
							<b-form-group id="value_date" label-for="value_date">
								<b-form-input class="mb-3 mt-2 field-container fields" type="text"
									v-model="data.trans_date" disabled></b-form-input>
							</b-form-group>
						</div>
						<div class="col-12 col-md-6">
							<label class="akkurate-dark" for="recorded_date">Purpose</label>
							<b-form-group id="recorded_date" label-for="recorded_date">
								<b-form-input class="mb-3 mt-2 field-container fields" type="text"
									v-model="data.account.account_type.base_type" disabled></b-form-input>
							</b-form-group>
						</div>
						<div class="col-12 col-md-6">
							<label class="akkurate-dark" for="recorded_date">Status</label>
							<b-form-group id="recorded_date" label-for="recorded_date">
								<b-form-input class="mb-3 mt-2 field-container fields" type="text"
									v-model="data.trans_status" disabled></b-form-input>
							</b-form-group>
						</div>

						<div class="col-12" v-if="
							data.trans_status !== 'APPROVED' &&
							data.trans_status !== 'COMPLETED' &&
							data.trans_status !== 'REVERSED' &&
							data.trans_status !== 'REJECTED' &&
							data.trans_status !== 'FAILED'">
							<label class="akkurate-dark" for="recorded_date">Select Bank</label>
							<b-form-group id="recorded_date" label-for="recorded_date">
								<multiselect id="bank" name="bank" class="mb-3 mt-2 field-container fields"
									aria-describedby="bank" :custom-label="custom_label" v-model="bank"
									:allow-empty="false" :options="bank_current_options">
								</multiselect>
							</b-form-group>
						</div>
						<div v-else class="col-12 col-md-6">
							<label class="akkurate-dark" for="recorded_date">Bank Selected</label>
							<b-form-group id="recorded_date" label-for="recorded_date">
								<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="coa_selected"
									disabled></b-form-input>
							</b-form-group>
						</div>
					</div>

					<div class="col-12 col-md-12">
						<label class="akkurate-dark" for="branch">Preview Cheque</label>
						<!-- <b-form-group id="branch" label-for="branch">
							<b-form-input class="mb-3 mt-2 field-container fields" type="file" v-model="getBranch" disabled></b-form-input>
						</b-form-group> -->
						<label class="akkurate-dark small">Preview</label>
						<img class="imagePreviewWrapper" :src="previewUrl" alt="File Preview" />
						<!-- <b-button type="button" @click="uploadFile" :disabled="upload_processing" class="akkurate-green-btn">
							<b-spinner v-if="spin_visible" small></b-spinner>
							<i v-if="success_visible" class="fas fa-check loading"></i>
							<i v-if="text_visible" class="fas fa-upload loading"></i>
							{{ upload }}
						</b-button> -->
					</div>

				</div>
			</div>

			<template #modal-footer="{ ok }">
				<div class="w-100">
					<!-- begin loader -->
					<!-- <beat-loader-component 
               class="float-left"
               v-if="isLoading"
               :isLoading="isLoading"
               ></beat-loader-component> -->
					<!-- end loader -->
					<!-- Emulate built in modal footer ok and cancel button actions -->
					<b-button @click="$bvModal.hide(String(data.id))" type="button"
						class="akkurate-grey-btn btn-size float-right border-0"><font-awesome-icon class="me-2"
							:icon="['fas', 'close']" />Close</b-button>
					<!-- <b-button @click="ok()" type="submit" class="akkurate-green-btn btn-size me-2 float-right border-0">Add</b-button>      -->
				</div>
			</template>

		</b-modal>
		<template>
			<div>
				<!-- Trigger button (could be hidden if you open programmatically) -->
				<!-- <b-button v-b-modal.reject-cheque-modal>Reject Cheque</b-button> -->

				<!-- The Modal -->
				<b-modal id="reject-cheque-modal" ref="rejectChequeModal" title="Reject Cheque" @ok="submitRejection"
					ok-title="Reject" ok-variant="danger" cancel-title="Cancel" :busy="isSaving">
					<div>
						<p>
							Are you sure you want to reject cheque number <strong>{{ data?.cheque_number }}</strong>?
						</p>
						<b-form-group label="Rejection Reason" label-for="rejection-reason">
							<b-form-textarea id="rejection-reason" v-model="rejectionReason"
								placeholder="Enter reason..." rows="3" required></b-form-textarea>
						</b-form-group>
						<b-alert v-if="error" variant="danger" show>{{ error }}</b-alert>
					</div>
					<template #modal-footer="{ ok }">
						<div class="w-100">
							<!-- end loader -->

							<!-- Emulate built in modal footer ok and cancel button actions -->
							<b-button @click="ok()" type="submit"
								class="akkurate-green-btn btn-size ms-2 float-right border-0">Yes</b-button>

							<b-button @click="$bvModal.hide('reject-cheque-modal')" type="button"
								class="akkurate-grey-btn btn-size float-right border-0"><font-awesome-icon class="me-2"
									:icon="['fas', 'close']" />No</b-button>
						</div>
					</template>
				</b-modal>
			</div>
		</template>
	</div>
</template>
<script>
import ApiService from "@/core/services/api.service";
import BeatLoaderComponent from "@/views/components/Loader/BeatLoaderComponent.vue";
import Multiselect from "vue-multiselect";

export default {
	name: "JournalView",
	props: [
		'data',
		"institution",
		"user",
		"bank_current_options"
	],
	components: {
		BeatLoaderComponent,
		Multiselect
	},
	data() {
		return {
			form: {
				branch: []
			},
			coa_selected: {},
			isLoading: false,
			chequeNumber: '', // Set this when opening the modal
			rejectionReason: '',
			isSaving: false,
			error: "",
			fields: [
				{ key: 'id', label: '#' },
				{ key: 'amount_requested', label: 'Amt Req' },
				{ key: 'amount_approved', label: 'Amt App' },
				{ key: 'dr_amount', label: 'Debit Amt' },
				{ key: 'cr_amount', label: 'Credit Amt' },
				{ key: 'dr_amount_approved', label: 'Debit Amt App' },
				{ key: 'cr_amount_approved', label: 'Credit Amt App' },
				{ key: 'coa_sub_head', label: 'COA Subhead' },
			],
			items: [],
			bank: "",
			stage_id: "",
			previewUrl: "",
		}
	},
	// mounted() {

	// },
	computed: {
		getBranch() {
			if (this.data.account.branch) {
				return this.data.account.branch.name;
			}
			return "";
		},
		getFullName() {
			const first_name =
				this.data.customer.first_name != undefined
					? this.data.customer.first_name
					: "";
			const middle_name =
				this.data.customer.middle_name != undefined
					? this.data.customer.middle_name
					: "";
			const last_name =
				this.data.customer.last_name != undefined
					? this.data.customer.last_name
					: "";
			return first_name + " " + middle_name + " " + last_name;
		},
	},
	methods: {
		custom_label({ code, name, coabranch }) {
			return `${code} - ${name} (${coabranch?.name})`
		},

		async getChequeView() {
			this.isLoading = true;
			// console.log("Start")
			// this.items = [];
			// this.details = {};
			//  this.search = "processing";
			//  this.isSearching = true;
			// console.log(this.data);
			await ApiService.get(`/journals/view/${this.data.id}`).then((response) => {
				const account = [];
				this.form = response.data.data;
				this.form.vouch_journal_coaaccounts.map((index) => {
					account.push({
						'id': index.id,
						'amount_approved': index.amount_approved,
						'amount_requested': index.amount_requested,
						'dr_amount': index.dr_amount,
						'cr_amount': index.cr_amount,
						'dr_amount_approved': index.dr_amount_approved,
						'cr_amount_approved': index.cr_amount_approved,
						'coa_sub_head': index.coa_sub_head.name,
					})
				});
				console.log(account)
				this.items = account
				this.isLoading = false;
			}).catch((error) => {
				this.isLoading = false
				console.log(error);
			})
		},
		async approveCheque() {
			if (Object.keys(this.bank)?.length > 0) {
				// this.data.trans_status = "APPROVED"
				const form = {
					'transaction_id': this.data.id,
					'amount': this.data.trans_amount,
					'coa_bank_id': this.bank?.id,
					'cheque_number': this.data.cheque_number
				}
				swal.fire({
					title: "Approve Cheque!",
					// title: "Successfull Saved",
					text: `Are you sure you want to approve cheque transaction ${this.data.code}?`,
					// text: 'CODE : 14345664565',
					confirmButtonColor: "#018673",
					icon: "info",
					allowOutsideClick: false,
					allowEscapeKey: false,
					showCancelButton: true, // Show the "Cancel" button
					confirmButtonText: "Yes", // Customize the text for the "OK" button
					cancelButtonText: "No", // Text for the custom button
					buttonsStyling: false, // Disable SweetAlert2 styling for buttons
					customClass: {
						confirmButton:
							"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
						cancelButton:
							"btn btn-size akkurate-ash modal-btn-width text-white", // Custom class for the custom button
					},
				}).then(async (result) => {
					if (result.isConfirmed) {
						await ApiService.post("/transactions/cheque/approve", form
						)
							.then((respp) => {
								toast.fire({
									icon: "success",
									title: respp.data?.message,
								});

								this.$bvModal.hide(String(this.data.id))
								this.$emit('refreshCheque');
							})
							.catch((error) => {
								if (error.response.data.message) {
									toast.fire({
										icon: "error",
										title: error.response.data.message,
									});
								} else {
									toast.fire({
										icon: "error",
										title: "An error occurred",
									});
								}
							})
							.finally((resp) => {
								this.isLoading = false;
							});
					} else if (result.isDismissed) {
					}
				});
			} else {
				this.$Progress.finish();
				swal.fire({
					// title: response.statusText,
					text: "Please Select Bank",
					icon: "warning",
					allowOutsideClick: true,
					allowEscapeKey: true,
					showCancelButton: false, // Show the "Cancel" button
					confirmButtonText: "okay", // Customize the text for the "OK" button
					buttonsStyling: false, // Disable SweetAlert2 styling for buttons
					customClass: {
						confirmButton:
							"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
					},
				});
			}
		},
		async clearCheque() {
			swal.fire({
				title: "Clear Cheque!",
				// title: "Successfull Saved",
				text: `Are you sure you want to clear cheque transaction ${this.data.code}?`,
				// text: 'CODE : 14345664565',
				confirmButtonColor: "#018673",
				icon: "info",
				allowOutsideClick: false,
				allowEscapeKey: false,
				showCancelButton: true, // Show the "Cancel" button
				confirmButtonText: "Yes", // Customize the text for the "OK" button
				cancelButtonText: "No", // Text for the custom button
				buttonsStyling: false, // Disable SweetAlert2 styling for buttons
				customClass: {
					confirmButton:
						"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
					cancelButton:
						"btn btn-size akkurate-ash modal-btn-width text-white", // Custom class for the custom button
				},
			}).then(async (result) => {
				if (result.isConfirmed) {
					await ApiService.post("/transactions/cheque/clear", {
						'transaction_id': this.data.id
					}).then((respp) => {
						toast.fire({
							icon: "success",
							title: respp.data?.message,
						});

						this.$bvModal.hide(String(this.data.id))
						this.$emit('refreshCheque');
					})
						.catch((error) => {
							if (error.response.data.message) {
								toast.fire({
									icon: "error",
									title: error.response.data.message,
								});
							} else {
								toast.fire({
									icon: "error",
									title: "An error occurred",
								});
							}
						})
						.finally((resp) => {
							this.isLoading = false;
						});
				} else if (result.isDismissed) {
				}
			});
		},
		// rejectCheque(filter = null) {
		// 	this.isSaving = true;
		// 	this.$Progress.start();
		// 	// swal.fire({
		// 	// 	title: "Reject Cheque",
		// 	// 	text: "Are you sure you want to reject cheque number " + this.data.cheque_number + "? Please provide a reason.",
		// 	// 	icon: "warning",
		// 	// 	input: "textarea",
		// 	// 	inputPlaceholder: "Enter rejection reason...",
		// 	// 	inputAttributes: {
		// 	// 		maxlength: 500,
		// 	// 		autocapitalize: "off",
		// 	// 		autocorrect: "off"
		// 	// 	},
		// 	// 	inputAutoFocus: true, // Ensures autofocus
		// 	// 	showCancelButton: true,
		// 	// 	confirmButtonColor: "#3085d6",
		// 	// 	cancelButtonColor: "#d33",
		// 	// 	confirmButtonText: "YES",
		// 	// 	cancelButtonText: "NO",
		// 	// 	allowOutsideClick: () => !swal.isLoading(),
		// 	// 	customClass: {
		// 	// 		cancelButton:
		// 	// 			"btn btn-size akkurate-green-gray modal-btn-width text-white me-2",
		// 	// 		confirmButton:
		// 	// 			"btn btn-size akkurate-green-btn modal-btn-width text-white me-2",
		// 	// 	},
		// 	// 	preConfirm: (reason) => {
		// 	// 		if (!reason || reason.trim() === "") {
		// 	// 			swal.showValidationMessage("Rejection reason is required");
		// 	// 			return false;
		// 	// 		}
		// 	// 		return reason;
		// 	// 	},
		// 	// 	didOpen: () => {
		// 	// 		// Fallback: manually focus the textarea
		// 	// 		const textarea = document.querySelector('.swal2-textarea');
		// 	// 		if (textarea) textarea.focus();
		// 	// 	}
		// 	// })
		// 	swal.fire({
		// 		title: "Reject Cheque",
		// 		text: "Please provide a reason.",
		// 		icon: "warning",
		// 		input: "textarea",
		// 		inputPlaceholder: "Enter rejection reason...",
		// 		showCancelButton: true,
		// 		confirmButtonText: "YES",
		// 		cancelButtonText: "NO"
		// 	});
		// },

		openRejectModal(chequeNumber) {
			this.chequeNumber = chequeNumber;
			this.rejectionReason = '';
			this.error = '';
			this.$refs.rejectChequeModal.show();
		},
		async submitRejection(evt) {
			this.isSaving = true;
			this.$Progress.start();
			if (!this.rejectionReason.trim()) {
				this.error = "Rejection reason is required.";
				evt.preventDefault(); // Prevent modal from closing
				return;
			}
			this.isSaving = true;
			this.error = '';
			try {
				// Replace with your API call
				await ApiService.post('/transactions/cheque/reject', {
					transaction_id: this.data.id, // or pass as prop
					rejection_reason: this.rejectionReason
				}).then((response) => {
					swal.fire({
						// title: response.statusText,
						text: response.data.message,
						icon: "success",
						allowOutsideClick: true,
						allowEscapeKey: true,
						showCancelButton: false, // Show the "Cancel" button
						confirmButtonText: "okay", // Customize the text for the "OK" button
						buttonsStyling: false, // Disable SweetAlert2 styling for buttons
						customClass: {
							confirmButton:
								"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
						},
					});
					this.$bvModal.hide(String(this.data.id));
					this.$refs.rejectChequeModal.hide();
					this.$emit('chequeApprovedAction');
					this.$Progress.finish();
				}).catch((error) => {
					console.log(error);
					this.$Progress.fail();
				});



			} catch (error) {
				this.error = error.response?.data?.message || 'Failed to reject cheque';
				evt.preventDefault(); // Prevent modal from closing
				this.$Progress.fail();
			} finally {
				this.isSaving = false;
				this.$Progress.fail();
			}
		},
		reverseCheque(filter = null) {
			this.isSaving = true;
			this.$Progress.start();
			swal.fire({
				title: "Reverse Loan",
				text:
					"Are you sure you want to reverse data number " +
					filter +
					" ?",
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "YES",
				cancelButtonText: "NO",
				allowOutsideClick: true,
				customClass: {
					cancelButton:
						"btn btn-size akkurate-green-gray modal-btn-width text-white me-2", // Custom class for the "NO" button
					confirmButton:
						"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "YES" button
				},
			}).then((result) => {
				if (result.value) {
					// this.$Progress.start();
					// ApiService.post("/loans/reverseCheque", {
					// 	loan_number: filter,
					// })
					// 	.then((response) => {
					// 		this.$Progress.finish();
					// 		swal.fire({
					// 			// title: response.statusText,
					// 			text: response.data.message,
					// 			icon: "success",
					// 			allowOutsideClick: true,
					// 			allowEscapeKey: true,
					// 			showCancelButton: false, // Show the "Cancel" button
					// 			confirmButtonText: "okay", // Customize the text for the "OK" button
					// 			buttonsStyling: false, // Disable SweetAlert2 styling for buttons
					// 			customClass: {
					// 				confirmButton:
					// 					"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
					// 			},
					// 		});
					// 		this.getSingleLoan();
					// 		this.$emit("loanApprovedAction");
					// 	})
					// 	.catch((error) => {
					// 		this.$Progress.fail();
					// 		swal.fire({
					// 			// title: response.statusText,
					// 			text: error.response?.data?.message,
					// 			icon: "error",
					// 			allowOutsideClick: true,
					// 			allowEscapeKey: true,
					// 			showCancelButton: false, // Show the "Cancel" button
					// 			confirmButtonText: "okay", // Customize the text for the "OK" button
					// 			buttonsStyling: false, // Disable SweetAlert2 styling for buttons
					// 			customClass: {
					// 				confirmButton:
					// 					"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
					// 			},
					// 		});
					// 	});
				}
			});
		},
		ModalOpened() {
			if (this.data.trans_status == 'APPROVED'
				|| this.data.trans_status == 'COMPLETED'
				|| this.data.trans_status == 'FAILED'
				|| this.data.trans_status == 'REJECTED'
				|| this.data.trans_status == 'REVERSED') {
				this.getProcessingCheque();
			}
		},
		async getProcessingCheque() {
			await ApiService.get("/transactions/processing/cheque/view/" + this.data.id)
				.then((response) => {
					console.log(response);
					this.coa_selected = response.data.data?.coa_subhead?.name;
				})
				.catch((error) => {
					// console.log(error);
				});
		},
	}
}
</script>

<style>
/* .modal .modal-content .modal-header{
        padding: 0rem 1rem 0rem 1rem !important;
    } */

.modal .modal-content .modal-title {
	flex-grow: 1 !important;
}

.modal .modal-body {
	padding: 0 1rem !important;
}

.tabel {
	background-color: transparent !important;
}
</style>